// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-picker-row .dropdown-toggle::after {\n  color: #ddd;\n}\n\n.history-picker-row__dropdown {\n  position: absolute;\n  margin-top: 0.5rem;\n  background-color: #fff;\n  z-index: 1;\n}\n\n.history-picker-row__dropdown .dropdown-item:hover {\n  background-color: #deebff;\n}\n\n.history-picker-row__dropdown .dropdown-item.active:hover {\n  background-color: #007bff;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
